import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Navigation = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    useEffect(() => {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () { resolve(); });
                script.addEventListener('error', function (e) { reject(e); });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }
        loadScript('./assets/js/mobilenav.js');
    }, []);

    // Marca activo el item del menú según la ruta actual. "Más información" es un
    // dropdown: se marca cuando estás en cualquiera de sus hijos.
    const isHome      = pathname === '/';
    const isAbout     = pathname.startsWith('/acerca-de') || pathname.startsWith('/presentacion');
    const isMoreInfo  = pathname.startsWith('/services-detail')
                        || pathname === '/personal-data'
                        || pathname === '/data-protection';
    const isPricing   = pathname.startsWith('/pricing');
    const isContact   = pathname.startsWith('/contact-us');

    return (
        <>
            <ul className="nav navbar-nav">
                <li className={isHome ? 'active' : ''}>
                    <NavLink to={"/"}>{t('navigation.home')}</NavLink>
                </li>
                <li className={isAbout ? 'active' : ''}>
                    <NavLink to={"/acerca-de"}>{t('navigation.about_us')}</NavLink>
                </li>
                <li className={isMoreInfo ? 'active' : ''}>
                    <NavLink to={""}>{t('navigation.more_info')}</NavLink>
                    <ul className="sub-menu">
                        <li>
                            <NavLink to={""}>{t('navigation.services.title')}</NavLink>
                            <ul className="sub-menu">
                                <li><NavLink to={"/services-detail-proyectos"}>{t('navigation.services.projects')}</NavLink></li>
                                <li><NavLink to={"/services-detail-finanzas"}>{t('navigation.services.finances')}</NavLink></li>
                                <li><NavLink to={"/services-detail-obra"}>{t('navigation.services.workPlan')}</NavLink></li>
                                <li><NavLink to={"/services-detail-administration"}>{t('navigation.services.systemAdmin')}</NavLink></li>
                                <li><NavLink to={"/services-detail-reportes"}>{t('navigation.services.reports')}</NavLink></li>
                                <li><NavLink to={"/services-detail-presupuestos"}>{t('navigation.services.budgets')}</NavLink></li>
                            </ul>
                        </li>
                        <li>
                            <NavLink to={""}>{t('navigation.dataProtection.title')}</NavLink>
                            <ul className="sub-menu">
                                <li><NavLink to={"/personal-data"}>{t('navigation.dataProtection.personalData')}</NavLink></li>
                                <li><NavLink to={"/data-protection"}>{t('navigation.dataProtection.database')}</NavLink></li>
                            </ul>
                        </li>
                    </ul>
                </li>
                {/* <li><NavLink to={"/faq"}>FAQ</NavLink></li> */}
                <li className={isPricing ? 'active' : ''}>
                    <NavLink to={"/pricing"}>{t('navigation.pricing')}</NavLink>
                </li>
                <li className={isContact ? 'active' : ''}>
                    <NavLink to={"/contact-us"}>{t('navigation.contact')}</NavLink>
                </li>
            </ul>
        </>
    );
};

export default Navigation;
